export const teamDropdownI18nDe = {
    teams: "Teams",
    findTeamPlaceholder: "Team finden",
};
